<!-- Review Modal -->
<!-- <div class="modal fade post-review-model">
  <div class="modal-dialog modal-dialog-custom modal-dialog-centered modal-theme modal-dialog-scrollable modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title mt-2 mb-2 fw-700" id="postReviewToProfileModelTitle">Create a Conversation</h4>
        <button type="button" class="close mt-2 font-32" aria-label="Close" data-dismiss="modal" (click) ="closePopup()">
          <span aria-hidden="true"><app-icon name="x" class="cx-icon--sm" aria-hidden="true"></app-icon></span>
        </button>
      </div>
      <div *ngIf="this.loader === true" class="loader"></div>
      <div class="modal-body px-0 pt-0">
        <p class="font-12 bg-very-light-warning p-3" >
          <b>Friendly Reminder:</b> CitizeX does not censor content but we expect all users to follow our community expectations of truthfulness and honesty. Beware that everyone who looks at your content will know you made it If what you say
          is not true, you could be liable for any damage you cause.
        </p>
        <form class="col-md-12 row m-0 px-3 my-3 square-form" (ngSubmit)="checkVlidation(categoryForm)" #categoryForm="ngForm" novalidate enctype="multipart/form-data">
          <div class="col-auto pl-0 pt-0">
            <img *ngIf="defaultProfile.profileImage == '' || defaultProfile.profileImage == null" src="../../../assets/images/noprofile2.png" class="btn btn-img-circle fix-avtar-3 mx-auto mt-0" alt="Page Image" />
            <img *ngIf="defaultProfile.profileImage != '' && defaultProfile.profileImage != null" [src]="defaultProfile.profileImage" onerror="this.src='../../../assets/images/noprofile2.png';" class="btn btn-img-circle fix-avtar-3 mx-auto mt-0" alt="Page Image" />
          </div>

          <div class="col pl-0">
            <p class="col-12 p-0 bold">
              {{ defaultProfile.profileName }} <app-icon name="circle-check" *ngIf="verified" class="font-success mx-2"></app-icon> <span class="fw-500">@{{ this.defaultProfile.tagName }}</span>
            </p>
            <div class="ng-autocomplete w-100 ng-autocomplete-font-12 mt-1">
              <ng-autocomplete
                name="search"
                id="search"
                class="w-100"
                placeHolder="@"
                #searchString=""
                [data]="searchSuggetionListForPost"
                [(ngModel)]="searchValueForPost"
                [itemTemplate]="itemTemplate"
                [notFoundTemplate]="notFoundTemplate"
                [minQueryLength]="2"
                (inputChanged)="onChangeSearch($event)"
                (selected)="selectEvent($event)"
                (keydown)="clear($event)"
              >
              </ng-autocomplete>
                <div *ngIf="categoryForm.submitted &&mentioned == false && postOnOwnProfile == false && postOnblockProfile == false" class="invalid-feedback d-block">
                  <span>This CitizeX username does not exists</span>
                </div>
                <div *ngIf="postOnOwnProfile == true" class="invalid-feedback d-block">
                  <span>You can not post on your own profile.</span>
                </div>
                <div *ngIf="postOnblockProfile == true" class="invalid-feedback d-block">
                  <span>This CitizeX username does not exists.</span>
                </div>
              <ng-template #itemTemplate let-item class="dropdown-menu search-dropdown">
                <a [innerHTML]="item"></a>
              </ng-template>

              <ng-template #notFoundTemplate let-notFound class="dropdown-menu search-dropdown">
                <div [innerHTML]="notFound"></div>
              </ng-template>
            </div>
            <div class="col-12 p-0 mt-2 z-index-100">
              <div class="form-group review-area ">


                <textarea
                  [(ngModel)]="review.content"
                  name="content"
                  id="content"
                  #reviewContent
                  class="form-control p-0 editor"
                  rows="10"
                  #content="ngModel"
                  (keyup)="checkContent(review.content)"
                  required
                  maxlength="300"
                  (searchTerm)="getSuggestions($event)"
                  (itemSelected)="itemSelected()"
                ></textarea>

                <div *ngIf="reviewImageCollection" [ngClass]="reviewImageCollection.length < 7 ? 'col-md-12 mb-2 post-gallery count-' + reviewImageCollection.length : 'col-md-12 post-gallery mt-2 count-6 plus'">
                  <ng-container *ngFor="let mediaFile of reviewImageCollection; let x = index">
                    <button  *ngIf="x < 6" [class]="'btn btn-img img a' + x" [ngClass]="{ video: mediaFile[1] == 'video' }">
                      <img *ngIf="mediaFile[1] == 'image'" [src]="mediaFile[0]" onerror="this.src='../../../assets/images/noprofile2.png';" alt="Post Image" [class]="'img-fluid i' + x" />
                      <video [poster]="thumbnailData[x]" *ngIf="mediaFile[1] == 'video'" width="100%" height="100%" controls [muted]="'muted'" preload="metadata">
                        <source [src]="mediaFile[0]" [type]="mediaFile[2]" />
                      </video>
                      <button type="button" class="btn view-btn delete view-only" (click)="deleteReviewMedia(x, reviewfileUpload); $event.preventDefault()" data-toggle="modal">
                        <span class="icon-inside"><app-icon name="trash-2"></app-icon></span>
                      </button>
                      <div class="view-more delete">
                        <button type="button" class="btn view-btn" (click)="onViewMoreReview(reviewImageCollection, x); $event.preventDefault()" data-toggle="modal">
                          <h2>{{ reviewImageCollection.length - 6 }} More</h2>
                        </button>
                        <button type="button" class="btn view-btn delete" (click)="deleteReviewMedia(x, reviewfileUpload); $event.preventDefault()" data-toggle="modal">
                          <span class="icon-inside"><app-icon name="trash-2"></app-icon></span>
                        </button>
                      </div>
                    </button>
                  </ng-container>
                </div>
                <div class="col-12 text-right p-0">
                  <button type="button" class="btn btn-link btn-tbl-link-theme font-14 p-0 icon-inside" (click)="reviewfileUpload.click()"><app-icon name="paperclip" class="font-14"></app-icon> Upload Media</button>
                </div>
                <input type="file" accept="image/jpg,image/jpeg,image/png,video/mp4,video/quicktime,video/*" class="custom-file-input d-none" #reviewfileUpload id="reviewfileUpload" (change)="uploadReviewfile($event)" multiple appImageOnly/>
              </div>
              <div *ngIf="imgloading == true" class="col-12 px-0 loader-custom mx-auto">
                <div class="view-profileLoader1"></div>
              </div>
            </div>
            <div *ngIf="mediaTypeInvalid" class="invalid-feedback d-block p-1">
              <span>Invalid media type</span>
            </div>
            <div *ngIf="contentInvalid" class="invalid-feedback d-block p-1">
              <span>The uploaded media was flagged by our safety system. Please choose a different file.</span>
            </div>
            <div *ngIf="categoryForm.submitted && content.invalid && this.reviewContentValidation === false" class="invalid-feedback d-block p-1">
              <span>Review cannot be blank.</span>
            </div>
            <div *ngIf="imageExceed" class="invalid-feedback d-block">
              <span>File size should be less than 25 MB</span>
            </div>
            <div *ngIf="maxFiles" class="invalid-feedback d-block">
              <span>Maximum 7 files can be added</span>
            </div>
            <div *ngIf="textContentValid === true" class="invalid-feedback d-block">
              <span>This content was flagged by our safety system. Please revise and try again</span>
            </div>

            <div class="col-12 pt-3">
              <div class="row justify-content-end">
                <div class="col-8 text-left p-0 d-none">
                  <button type="button" class="btn btn-link btn-tbl-link-theme font-14 p-0 pt-1 icon-inside" (click)="reviewfileUpload.click()"><app-icon name="paperclip" class="font-14"></app-icon> Upload Media</button>
                </div>
                <div class="col-4 p-0 text-right">
                  <button type="submit" [disabled]="disable" class="btn btn-black post">Post</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div> -->
<!----------------------Create-Conversation-Modal------->
<div
  [ngClass]="
    pageMode ? 'post-composer-page__surface' : 'modal fade post-review-model'
  "
  [attr.id]="pageMode ? null : 'postReviewModel'"
  [attr.tabindex]="pageMode ? null : '-1'"
  [attr.role]="pageMode ? null : 'dialog'"
  [attr.aria-labelledby]="
    pageMode ? 'postComposerTitle' : 'postReviewToProfileModelTitle'
  "
  [attr.aria-hidden]="pageMode ? null : 'true'"
  [attr.data-backdrop]="pageMode ? null : 'static'"
  [attr.data-keyboard]="pageMode ? null : 'false'"
>
  <div
    [ngClass]="
      pageMode
        ? 'post-composer-page__dialog conversation-Modal'
        : 'modal-dialog modal-dialog-centered modal-lg modal-dialog-custom modal-theme modal-dialog-scrollable conversation-Modal'
    "
    [attr.role]="pageMode ? null : 'document'"
  >
    <div class="modal-content" [class.post-composer-page__content]="pageMode">
      <div class="modal-header">
        <button
          *ngIf="pageMode"
          type="button"
          class="post-composer-page__back"
          [attr.aria-label]="isPollComposer ? 'Back to polls' : 'Back to posts'"
          (click)="closePopup(categoryForm, categoryForm1)"
        >
          <app-icon
            name="chevron-left"
            class="cx-icon--md"
            aria-hidden="true"
          ></app-icon>
          <span class="post-composer-page__back-label">{{
            isPollComposer ? 'Polls' : 'Posts'
          }}</span>
        </button>
        <h4
          class="modal-title mt-2 mb-2 fw-700 font-18"
          [attr.id]="
            pageMode ? 'postComposerTitle' : 'postReviewToProfileModelTitle'
          "
        >
          <span *ngIf="pageMode">{{
            isPollComposer ? 'New poll' : 'New post'
          }}</span>
          <span *ngIf="!pageMode && reviewType == 'chat'">{{
            review.id > 0 && isEditUrl
              ? 'Update Conversation'
              : 'Create a
            Post'
          }}</span>
          <span *ngIf="!pageMode && reviewType == 'polling'">{{
            review.id > 0 && isEditUrl ? 'Update Poll' : 'Create a Poll'
          }}</span>
        </h4>
        <button
          *ngIf="!pageMode"
          type="button"
          class="close mt-2 font-32"
          aria-label="Close"
          (click)="closePopup(categoryForm, categoryForm1)"
        >
          <span aria-hidden="true"
            ><app-icon
              name="x"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon
          ></span>
        </button>
      </div>
      <div class="modal-body p-0">
        <div *ngIf="!pageMode" class="col-12 px-0">
          <p class="font-12 bg-very-light-warning p-3">
            <b>Friendly Reminder:&nbsp;</b>We expect all users to follow our
            community expectations of truthfulness, honesty, and respect.
            Violent or explicit content not allowed. By commenting, you agree to
            the community guidelines of the CitizeX community which can be
            viewed
            <a
              class="btn-link btn-link-theme p-0 cursor-pointer"
              (click)="openCommunityModal($event)"
              >here.</a
            >
          </p>
        </div>
        <div
          *ngIf="editorLoading && reviewType === 'chat'"
          class="text-center py-4"
        >
          <div class="citizex-spinner" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <section
          *ngIf="pageMode && showCommunityExpectations"
          class="post-composer-page__guidelines mx-4 my-3"
          aria-live="polite"
        >
          <h2 class="font-18 fw-700">Community Expectations</h2>
          <p>
            Be respectful, truthful, and accurate. Do not post harassment, hate
            speech, spam, private information, or deliberate misinformation.
          </p>
          <p class="mb-0">
            By publishing, you agree to follow CitizeX community guidelines.
          </p>
          <div class="d-flex justify-content-end mt-3">
            <button
              type="button"
              class="btn btn-outline-black conversation-modal-btn fw-600 text-uppercase font-16"
              (click)="communityclose()"
            >
              Back
            </button>
            <button
              type="button"
              class="btn btn-black ml-2 conversation-modal-btn fw-600 text-uppercase font-16"
              (click)="postAReview(categoryForm)"
            >
              Agree and post
            </button>
          </div>
        </section>
        <form
          class="px-4 py-3 cx-standard-form"
          [class.post-composer-page__form]="pageMode"
          (ngSubmit)="checkVlidation(categoryForm)"
          #categoryForm="ngForm"
          novalidate
          enctype="multipart/form-data"
          [hidden]="reviewType !== 'chat'"
          [style.visibility]="editorLoading ? 'hidden' : 'visible'"
          [style.display]="showCommunityExpectations ? 'none' : null"
        >
          <div>
            <section
              *ngIf="pageMode"
              class="post-composer-page__author"
              aria-label="Post author and reply audience"
            >
              <div class="post-composer-page__author-identity">
                <img
                  *ngIf="defaultProfile.profileImage; else profileInitial"
                  class="post-composer-page__avatar"
                  [src]="defaultProfile.profileImage"
                  [alt]="defaultProfile.profileName || 'Profile image'"
                />
                <ng-template #profileInitial>
                  <span
                    class="post-composer-page__avatar post-composer-page__avatar--initial"
                    aria-hidden="true"
                  >
                    {{ (defaultProfile.profileName || 'C').charAt(0) }}
                  </span>
                </ng-template>
                <div class="post-composer-page__author-copy">
                  <strong>{{
                    defaultProfile.profileName || 'Your page'
                  }}</strong>
                  <span *ngIf="defaultProfile.tagName"
                    >&#64;{{ defaultProfile.tagName }}</span
                  >
                </div>
              </div>
              <div class="post-composer-page__audience">
                <button
                  type="button"
                  class="post-composer-page__audience-trigger"
                  (click)="showReplyAudienceMenu = !showReplyAudienceMenu"
                  [attr.aria-expanded]="showReplyAudienceMenu"
                  aria-haspopup="listbox"
                >
                  <app-icon
                    name="globe"
                    class="cx-icon--sm"
                    aria-hidden="true"
                  ></app-icon>
                  <span>{{ replyAudienceLabel }}</span>
                  <app-icon
                    name="chevron-down"
                    class="cx-icon--xs"
                    aria-hidden="true"
                  ></app-icon>
                </button>
                <div
                  *ngIf="showReplyAudienceMenu"
                  class="post-composer-page__audience-menu"
                  role="listbox"
                  aria-label="Choose who can reply"
                >
                  <button
                    type="button"
                    role="option"
                    [attr.aria-selected]="!review.isConstituentsOnlyReply"
                    (click)="setReplyAudience(false)"
                  >
                    Anyone can reply
                  </button>
                  <button
                    type="button"
                    role="option"
                    [attr.aria-selected]="review.isConstituentsOnlyReply"
                    (click)="setReplyAudience(true)"
                  >
                    Only my constituents can reply
                  </button>
                </div>
              </div>
            </section>
            <div
              class="col-12 my-2"
              *ngIf="
                !pageMode &&
                user != null &&
                (user?.isPolitician ||
                  (user?.defaultProfileId == null &&
                    user?.reviewProfileId != null))
              "
            >
              <div class="form-group mt-0">
                <div class="checkbox">
                  <input
                    type="checkbox"
                    id="remMe"
                    tabindex="5"
                    [(ngModel)]="review.isConstituentsOnlyReply"
                    name="review.isConstituentsOnlyReply"
                  />
                  <label for="remMe" class="font-16"
                    >Only allow my constituents to reply</label
                  >
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group mt-0">
                <div [class.post-composer-page__field-label-row]="pageMode">
                  <label
                    [attr.for]="pageMode ? 'post-subject' : 'subjectModel'"
                    class="fw-700 font-18"
                    >{{ pageMode ? 'Title' : 'Subject' }}</label
                  >
                  <span *ngIf="pageMode" class="post-composer-page__counter"
                    >{{ review.subject.length }} / 120</span
                  >
                </div>
                <input
                  type="text"
                  autocomplete="off"
                  [(ngModel)]="review.subject"
                  class="form-control conversation-modal-input subject-input px-3"
                  [class.post-composer-page__input]="pageMode"
                  [attr.id]="pageMode ? 'post-subject' : 'subjectModel'"
                  [placeholder]="pageMode ? 'What is this post about?' : null"
                  name="subjectModel"
                  #subjectModel="ngModel"
                  [attr.maxlength]="pageMode ? 120 : null"
                  NoLeadingWhitespace
                />
                <div
                  *ngIf="
                    categoryForm.submitted &&
                    (review.subject == '' ||
                      review.subject == undefined ||
                      review.subject == null)
                  "
                  class="invalid-feedback d-block"
                >
                  <span *ngIf="review.subject == '' || review.subject == null"
                    >Subject cannot be blank.</span
                  >
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <div [class.post-composer-page__field-label-row]="pageMode">
                  <label
                    [attr.for]="pageMode ? 'post-content' : 'content'"
                    class="fw-700 font-18"
                    >{{ pageMode ? 'Body' : 'Description' }}</label
                  >
                  <span *ngIf="pageMode" class="post-composer-page__counter"
                    >{{ postBodyCharacterCount }} / 1000</span
                  >
                </div>
                <ng-container *ngIf="pageMode; else legacyPostEditor">
                  <div class="post-composer-page__editor">
                    <ngx-editor-menu
                      [editor]="postComposerEditor"
                      [toolbar]="postComposerToolbar"
                    ></ngx-editor-menu>
                    <ngx-editor
                      id="post-content"
                      name="content"
                      [editor]="postComposerEditor"
                      [(ngModel)]="review.content"
                      [spellcheck]="true"
                      placeholder="Say what you think, and why."
                      required
                    ></ngx-editor>
                  </div>
                  <div
                    *ngIf="
                      categoryForm.submitted && postBodyCharacterCount === 0
                    "
                    class="invalid-feedback d-block"
                  >
                    <span>Post body cannot be blank.</span>
                  </div>
                  <div
                    *ngIf="postBodyExceedsLimit"
                    class="invalid-feedback d-block"
                  >
                    <span
                      >Keep the post body to 1,000 characters or fewer.</span
                    >
                  </div>
                </ng-container>
                <ng-template #legacyPostEditor>
                  <textarea
                    [(ngModel)]="review.content"
                    name="content"
                    id="content"
                    #postContentEditor
                    class="form-control p-0 editor"
                    #content="ngModel"
                    required
                    maxlength="1000"
                    (searchTerm)="getSuggestions($event)"
                    (itemSelected)="itemSelected()"
                    NoLeadingWhitespace
                  ></textarea>
                  <div
                    *ngIf="
                      categoryForm.submitted &&
                      content.invalid &&
                      this.reviewContentValidation === false
                    "
                    class="invalid-feedback d-block"
                  >
                    <span *ngIf="this.reviewContentValidation === false"
                      >Review cannot be blank.</span
                    >
                    <span *ngIf="content.errors?.['maxlength']"
                      >You've reached the maximum limit of 1000
                      characters.</span
                    >
                  </div>
                </ng-template>
                <div
                  *ngIf="textContentValid === true"
                  class="invalid-feedback d-block"
                >
                  <span
                    >This content was flagged by our safety system. Please
                    revise and try again</span
                  >
                </div>
                <div
                  *ngIf="categoryForm.submitted && textContentLength"
                  class="invalid-feedback d-block"
                >
                  <span
                    >You've reached the maximum limit of 1000 characters.</span
                  >
                </div>
                <div *ngIf="submissionError" class="invalid-feedback d-block">
                  {{ submissionError }}
                </div>
              </div>
            </div>
            <div *ngIf="pageMode" class="post-composer-page__guideline">
              <app-icon
                name="circle-alert"
                class="cx-icon--sm"
                aria-hidden="true"
              ></app-icon>
              <p>
                Truthfulness, honesty and respect are expected. No violent or
                explicit content.
                <button type="button" (click)="openCommunityModal($event)">
                  Community guidelines
                </button>
              </p>
            </div>
            <div
              class="col-12 text-sm-right mt-3 mb-2"
              [class.post-composer-page__footer]="pageMode"
            >
              <button
                id="btn-chat-cancel"
                type="button"
                class="btn btn-outline-black conversation-modal-btn fw-600 text-uppercase font-18"
                [class.post-composer-page__button]="pageMode"
                aria-label="Close"
                (click)="closePopup(categoryForm, categoryForm1)"
              >
                Cancel
              </button>
              <button
                id="btn-chat-post"
                type="submit"
                [disabled]="disable || (pageMode && !postFormReady)"
                class="btn btn-black ml-2 conversation-modal-btn fw-600 text-uppercase font-18"
                [class.post-composer-page__button]="pageMode"
                [class.post-composer-page__button--primary]="pageMode"
                (click)="preparePostSubmission()"
              >
                {{
                  review.id > 0 && isEditUrl && reviewType == 'chat'
                    ? 'Update'
                    : 'Post'
                }}
              </button>
            </div>
          </div>
        </form>
        <!------------Polling-Section-Start------------------>
        <form
          class="px-4 py-3 cx-standard-form"
          [class.post-composer-page__form]="isPollComposer"
          [class.poll-composer-page__form]="isPollComposer"
          #categoryForm1="ngForm"
          (ngSubmit)="checkPollFormValidation(categoryForm1)"
          [hidden]="reviewType !== 'polling' || !review.pollDTO"
        >
          <div>
            <section
              *ngIf="isPollComposer"
              class="post-composer-page__author"
              aria-label="Poll author and voting audience"
            >
              <div class="post-composer-page__author-identity">
                <img
                  *ngIf="defaultProfile.profileImage; else pollProfileInitial"
                  class="post-composer-page__avatar"
                  [src]="defaultProfile.profileImage"
                  [alt]="defaultProfile.profileName || 'Profile image'"
                />
                <ng-template #pollProfileInitial>
                  <span
                    class="post-composer-page__avatar post-composer-page__avatar--initial"
                    aria-hidden="true"
                  >
                    {{ (defaultProfile.profileName || 'C').charAt(0) }}
                  </span>
                </ng-template>
                <div class="post-composer-page__author-copy">
                  <strong>{{
                    defaultProfile.profileName || 'Your page'
                  }}</strong>
                  <span *ngIf="defaultProfile.tagName"
                    >&#64;{{ defaultProfile.tagName }}</span
                  >
                </div>
              </div>
              <div
                class="post-composer-page__audience poll-composer-page__audience"
              >
                <button
                  type="button"
                  class="post-composer-page__audience-trigger"
                  (click)="showReplyAudienceMenu = !showReplyAudienceMenu"
                  [attr.aria-expanded]="showReplyAudienceMenu"
                  aria-haspopup="listbox"
                >
                  <app-icon
                    name="globe"
                    class="cx-icon--sm"
                    aria-hidden="true"
                  ></app-icon>
                  <span>{{ pollAudienceLabel }}</span>
                  <app-icon
                    name="chevron-down"
                    class="cx-icon--xs"
                    aria-hidden="true"
                  ></app-icon>
                </button>
                <div
                  *ngIf="showReplyAudienceMenu"
                  class="post-composer-page__audience-menu"
                  role="listbox"
                  aria-label="Choose who can vote"
                >
                  <button
                    type="button"
                    role="option"
                    [attr.aria-selected]="!review.isConstituentsOnlyReply"
                    (click)="setReplyAudience(false)"
                  >
                    Anyone can vote
                  </button>
                  <button
                    type="button"
                    role="option"
                    [attr.aria-selected]="review.isConstituentsOnlyReply"
                    (click)="setReplyAudience(true)"
                  >
                    Only my constituents can vote
                  </button>
                </div>
              </div>
            </section>
            <div class="col-12">
              <div *ngIf="textContentValid === true" class="text-danger">
                <p class="fw-600 mb-1">
                  This content was flagged by our safety system. Please revise
                  and try again.
                </p>
              </div>
            </div>
            <div class="col-12" *ngIf="review.pollDTO && !isPollComposer">
              <div class="form-group mt-0">
                <label class="font-16 fw-700">Poll Duration</label>
                <select
                  class="form-select polling-select-input"
                  name="polldays"
                  id="polldays"
                  [(ngModel)]="review.pollDTO.pollDurationInDays"
                >
                  <option *ngFor="let day of daysArray" [ngValue]="day">
                    {{ day === 1 ? '1 Day' : day + ' Days' }}
                  </option>
                </select>
              </div>
            </div>
            <div
              class="col-12 mb-2 ml-2 mt-3"
              *ngIf="
                !pageMode &&
                user != null &&
                (user?.isPolitician ||
                  (user?.defaultProfileId == null &&
                    user?.reviewProfileId != null))
              "
            >
              <div class="form-group mt-1">
                <div class="checkbox">
                  <input
                    type="checkbox"
                    id="remMe"
                    tabindex="5"
                    [(ngModel)]="review.isConstituentsOnlyReply"
                    name="review.isConstituentsOnlyReply_1"
                  />
                  <label for="remMe" class="font-16"
                    >Only allow my constituents to reply</label
                  >
                </div>
              </div>
            </div>
            <div class="col-12" *ngIf="review.pollDTO">
              <div
                class="form-group"
                [class.poll-composer-page__question]="isPollComposer"
              >
                <div
                  [class.post-composer-page__field-label-row]="isPollComposer"
                >
                  <label class="font-16 fw-700">{{
                    isPollComposer ? 'Question' : 'Your Question'
                  }}</label>
                  <span
                    *ngIf="isPollComposer"
                    class="post-composer-page__counter"
                    >{{ review.pollDTO.question.length }} / 300</span
                  >
                </div>
                <textarea
                  class="form-control textaera-input"
                  [class.poll-composer-page__question-input]="isPollComposer"
                  name="question"
                  id="question"
                  maxlength="300"
                  [attr.rows]="isPollComposer ? 5 : null"
                  [(ngModel)]="review.pollDTO.question"
                  #question="ngModel"
                  (searchTerm)="getSuggestions($event)"
                  (itemSelected)="itemSelected()"
                  [ngModelOptions]="{ standalone: true }"
                  required
                  NoLeadingWhitespace
                  [placeholder]="
                    isPollComposer ? 'Ask one thing, in one sentence.' : null
                  "
                ></textarea>
                <div
                  *ngIf="categoryForm1.submitted && question.invalid"
                  class="text-danger"
                >
                  <small>Your question is required.</small>
                </div>
                <!-- <div *ngIf="textContentValid === true" class="text-danger">
                  <small>This content was flagged by our safety system. Please revise and try again.</small>
                </div> -->
              </div>
            </div>
            <div
              *ngIf="isPollComposer"
              class="post-composer-page__field-label-row"
            >
              <label>Answers</label>
              <span class="post-composer-page__counter">Two or more</span>
            </div>
            <div
              class="col-12 d-flex flex-wrap"
              *ngIf="review.pollDTO"
              [class.poll-composer-page__answers]="isPollComposer"
            >
              <ng-container
                *ngFor="let option of review.pollDTO.options; let i = index"
              >
                <div
                  class="form-group col-10 px-0"
                  [class.poll-composer-page__answer]="isPollComposer"
                >
                  <span
                    *ngIf="isPollComposer"
                    class="poll-composer-page__answer-number"
                    >{{ i + 1 }}</span
                  >
                  <label class="fw-700 font-16" [class.sr-only]="isPollComposer"
                    >Option {{ i + 1 }}</label
                  >
                  <input
                    type="text"
                    class="conversation-modal-input px-3 cx-form-control"
                    [class.poll-composer-page__answer-input]="isPollComposer"
                    [(ngModel)]="option.optionText"
                    name="option{{ i }}"
                    id="pollOption{{ i }}"
                    #optionModel="ngModel"
                    required
                    NoLeadingWhitespace
                    maxlength="100"
                    [placeholder]="isPollComposer ? 'Answer ' + (i + 1) : null"
                  />
                  <div
                    *ngIf="categoryForm1.submitted && optionModel.invalid"
                    class="text-danger"
                  >
                    <small>Option {{ i + 1 }} is required.</small>
                  </div>
                </div>
                <div
                  class="col-2 d-flex align-items-end mt-lg-2"
                  [class.poll-composer-page__answer-action]="isPollComposer"
                  style="height: 87px"
                >
                  <app-icon
                    name="plus"
                    id="addOptionBtn"
                    *ngIf="
                      !isPollComposer &&
                      i === review.pollDTO.options.length - 1 &&
                      review.pollDTO.options.length < 8
                    "
                    class="cx-icon--md add-icon-img"
                    role="button"
                    tabindex="0"
                    aria-label="Add option"
                    (click)="addOption()"
                    (keydown.enter)="addOption()"
                  ></app-icon>
                  <app-icon
                    name="trash-2"
                    class="font-24"
                    id="deleteOption{{ i }}"
                    *ngIf="
                      !isPollComposer &&
                      i > 0 &&
                      (i !== review.pollDTO.options.length - 1 || i == 7)
                    "
                    (click)="deleteOption(i)"
                  ></app-icon>
                  <button
                    *ngIf="isPollComposer"
                    type="button"
                    class="poll-composer-page__remove-answer"
                    aria-label="Remove answer"
                    [disabled]="review.pollDTO.options.length <= 2"
                    (click)="deleteOption(i)"
                  >
                    <app-icon
                      name="x"
                      class="cx-icon--sm"
                      aria-hidden="true"
                    ></app-icon>
                  </button>
                </div>
              </ng-container>
            </div>
            <button
              *ngIf="
                isPollComposer &&
                review.pollDTO &&
                review.pollDTO.options.length < 8
              "
              type="button"
              class="poll-composer-page__add-answer"
              (click)="addOption()"
            >
              <app-icon
                name="plus"
                class="cx-icon--xs"
                aria-hidden="true"
              ></app-icon>
              Add answer
            </button>
            <section
              *ngIf="isPollComposer && review.pollDTO"
              class="poll-composer-page__duration"
            >
              <span class="poll-composer-page__duration-label"
                >How long is it open?</span
              >
              <div
                class="poll-composer-page__duration-options"
                role="group"
                aria-label="Poll duration"
              >
                <button
                  *ngFor="let day of pollDurationQuickOptions"
                  type="button"
                  [class.is-selected]="
                    review.pollDTO.pollDurationInDays === day
                  "
                  [attr.aria-pressed]="
                    review.pollDTO.pollDurationInDays === day
                  "
                  (click)="review.pollDTO.pollDurationInDays = day"
                >
                  {{ pollDurationLabel(day) }}
                </button>
              </div>
              <p>
                <app-icon
                  name="clock"
                  class="cx-icon--xs"
                  aria-hidden="true"
                ></app-icon>
                {{ pollClosingLabel }}
              </p>
            </section>
            <div *ngIf="isPollComposer" class="post-composer-page__guideline">
              <app-icon
                name="circle-alert"
                class="cx-icon--sm"
                aria-hidden="true"
              ></app-icon>
              <p>
                Truthfulness, honesty and respect are expected. No violent or
                explicit content.
                <button type="button" (click)="openCommunityModal($event)">
                  Community guidelines
                </button>
              </p>
            </div>
            <div
              class="col-12 text-sm-right mt-4 mb-2"
              [class.post-composer-page__footer]="isPollComposer"
            >
              <button
                id="pollCancelBtn"
                type="button"
                class="btn btn-outline-black conversation-modal-btn fw-600 text-uppercase font-18"
                [class.post-composer-page__button]="isPollComposer"
                aria-label="Close"
                (click)="closePopup(categoryForm, categoryForm1)"
              >
                Cancel
              </button>
              <button
                id="pollPostBtn"
                type="submit"
                [disabled]="disable || (isPollComposer && !pollFormReady)"
                class="btn btn-black ml-2 conversation-modal-btn fw-600 text-uppercase font-18"
                [class.post-composer-page__button]="isPollComposer"
                [class.post-composer-page__button--primary]="isPollComposer"
              >
                {{
                  review.id > 0 && isEditUrl && reviewType == 'polling'
                    ? 'Update'
                    : isPollComposer
                    ? 'Publish poll'
                    : 'Post'
                }}
              </button>
            </div>
          </div>
        </form>
        <!------------Polling-Section-end------------------>
      </div>
    </div>
  </div>
</div>
<!-- Success Modal -->
<div
  class="modal fade"
  *ngIf="!pageMode"
  id="successModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered modal-sm"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body">
        <h1 class="text-center font-success">
          <app-icon name="circle-check" class="font-40"></app-icon>
        </h1>
        <h6 class="text-center bold my-3 theme-color">
          {{
            isEditSuccess
              ? 'Review successfully updated !'
              : 'Review successfully posted !'
          }}
        </h6>
        <!-- <p  [routerLink]="['/profile/view-profile/',profile.profileId]" class="text-center theme-color">Review posted Successfully data-dismiss="modal" !</p> -->
        <div class="col-12 text-center">
          <button
            id="btn-review-ok"
            type="button"
            class="btn btn-outline-black mt-4 mb-2 mx-2 py-1 font-12"
            (click)="reloadPage()"
          >
            OK
          </button>
        </div>
      </div>
      <!-- .modal-body -->
    </div>
    <!-- .modal-content -->
  </div>
  <!-- .modal-dialog -->
</div>

<div
  class="modal fade"
  *ngIf="!pageMode"
  id="pollingSuccessModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered modal-sm"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body">
        <h1 class="text-center font-success">
          <app-icon name="circle-check" class="font-40"></app-icon>
        </h1>
        <h6 class="text-center bold my-3 theme-color">
          {{
            isEditSuccess
              ? 'Poll updated successfully!'
              : 'Poll posted successfully!'
          }}
        </h6>
        <!-- <p  [routerLink]="['/profile/view-profile/',profile.profileId]" class="text-center theme-color">Review posted Successfully data-dismiss="modal" !</p> -->
        <div class="col-12 text-center">
          <button
            id="pollOkBtn"
            type="button"
            class="btn btn-outline-black mt-4 mb-2 mx-2 py-1 font-12"
            (click)="reloadPage()"
          >
            OK
          </button>
        </div>
      </div>
      <!-- .modal-body -->
    </div>
    <!-- .modal-content -->
  </div>
  <!-- .modal-dialog -->
</div>
<!-- #successModal -->
<!-- Success Modal Ends -->
<!-- Claimed Review Success Modal -->
<div
  class="modal fade"
  *ngIf="!pageMode"
  id="claimedReviewModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered modal-sm"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body">
        <h1 class="text-center font-success">
          <app-icon name="circle-check" class="font-40"></app-icon>
        </h1>
        <h6 class="text-center bold my-3 theme-color">
          Your claim request is still under review.
        </h6>
        <p class="text-center theme-color">
          Your conversation post has been saved and will go live once your claim
          request is approved.
        </p>
        <div class="col-12 text-center">
          <button
            type="button"
            class="btn btn-black mt-4 mb-2 mx-2 py-1 font-12"
            data-dismiss="modal"
            (click)="reloadPage()"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- #claimedReviewModal -->
<!-- Claimed Review Success Modal Ends -->
<!-- Success Modal Ends -->
<!-- Review Modal -->

<div
  class="modal fade"
  *ngIf="!pageMode"
  id="postAReviewImgModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="postAReviewImgModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-carousel" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <app-icon name="x" aria-hidden="true"></app-icon>
        </button>
        <div
          id="carouselPostAReview"
          class="carousel slide"
          data-ride="carousel"
        >
          <ol class="carousel-indicators">
            <li
              *ngFor="let media of viewMoreMedia; let x = index"
              data-target="#carouselPostAReview"
              [attr.data-slide-to]="x"
              [ngClass]="viewMoreMediaId == x ? 'active' : ''"
            ></li>
          </ol>
          <div class="carousel-inner">
            <div
              *ngFor="let media of viewMoreMedia; let x = index"
              class="carousel-item"
              [id]="'carousel-item-' + x"
              [ngClass]="{ active: viewMoreMediaId === x }"
            >
              <img
                [src]="media[0]"
                onerror="this.src='../../../assets/images/noprofile2.png';"
                class="img-fluid"
                alt="..."
              />
              <!-- <video src="Balloon.mp4" autoplay="true" loop="true"></video> -->
            </div>
          </div>
          <a
            class="carousel-control-prev"
            href="#carouselPostAReview"
            role="button"
            data-slide="prev"
          >
            <app-icon name="circle-chevron-left" class="bold"></app-icon>
            <span class="sr-only">Previous</span>
          </a>
          <a
            class="carousel-control-next"
            href="#carouselPostAReview"
            role="button"
            data-slide="next"
          >
            <app-icon name="circle-chevron-right" class="bold"></app-icon>
            <span class="sr-only">Next</span>
          </a>
        </div>
        <!-- /#carouselPostAReview -->
      </div>
      <!-- /.modal-body -->
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-carousel -->
</div>
<!-- /.modal -->

<div
  class="modal fade create-profile-model"
  *ngIf="!pageMode"
  id="createProfileModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="createProfileModalTitle"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-custom modal-theme modal-dialog-scrollable"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="createProfileModalTitle">Create Page</h4>
        <button
          type="button"
          class="close"
          (click)="closeCreatePageModal()"
          aria-label="Close"
          data-dismiss="modal"
        >
          <span aria-hidden="true"
            ><app-icon
              name="x"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon
          ></span>
        </button>
      </div>
      <div class="modal-body p-0" *ngIf="showCreatePopup">
        <app-create-profile
          [isPopup]="true"
          name="{{ username }}"
        ></app-create-profile>
      </div>
    </div>
  </div>
</div>
<!----------------------Post-Modal----------------->
<div
  class="modal fade post-modal community-reminder-modal"
  *ngIf="!pageMode"
  id="postModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog modal-dialog-centered modal-theme" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Community Reminder</h5>
        <button
          type="button"
          class="close font-32"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true"
            ><app-icon
              name="x"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon
          ></span>
        </button>
      </div>
      <div class="modal-body">
        <p class="theme-color text-justify">
          Friendly Reminder! Citizex does not censor content but we expect all
          users to follow our community expectations of truthfulness and
          honesty. Beware that everyone who looks at your content will know you
          made it. If what you said is not true, you could be liable for any
          damage you cause.
        </p>
        <div class="col-12 text-center">
          <button
            class="btn btn-black mt-4 mb-2 mx-2 py-2 px-sm-2 px-3 font-14"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!----------------------Post-Modal-end---------------->
<div
  class="modal fade community-exception-modal"
  *ngIf="!pageMode"
  id="postModal2"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-centered modal-theme modal-dialog-scrollable modal-scroll modal-lg"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Community Expectations
        </h5>
        <button
          type="button"
          class="close font-32"
          data-dismiss="modal"
          aria-label="Close"
          (click)="communityclose()"
        >
          <span aria-hidden="true"
            ><app-icon
              name="x"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon
          ></span>
        </button>
      </div>
      <div class="modal-body">
        <p class="theme-color text-left my-2">
          <span class="fw-700">Respectful Conduct:</span> Users are expected to
          engage in civil and respectful discourse. Personal attacks,
          harassment, hate speech, or discriminatory language of any kind are
          not tolerated. Disagreements should be expressed respectfully.
        </p>
        <p class="theme-color text-left my-2">
          <span class="fw-700">Transparency:</span> Users are required to use
          their real identities to interact with others on CitizeX. Transparency
          fosters trust and credibility within the community.
        </p>
        <p class="theme-color text-left my-2">
          <span class="fw-700">Factual and Accurate Information:</span> Users
          are encouraged to provide accurate information and support their
          claims with credible sources whenever possible. While differing
          opinions are allowed, spreading deliberate misinformation or
          falsehoods is discouraged. Users should be aware that they may be held
          liable for damages caused by the dissemination of false information.
        </p>
        <p class="theme-color text-left my-2">
          <span class="fw-700">Open-Mindedness:</span> Users are encouraged to
          be open-minded and consider different perspectives. Constructive
          debates are encouraged, and users should strive to understand and
          engage with diverse viewpoints.
        </p>
        <p class="theme-color text-left my-2">
          <span class="fw-700">No Spam or Promotions:</span> Users should
          refrain from spamming the platform with irrelevant content or
          promotional materials. Promotions should be relevant to the political
          discourse and adhere to the platform's guidelines.
        </p>
        <p class="theme-color text-left my-2">
          <span class="fw-700">Respect Privacy:</span> Users should respect the
          privacy of others and should not share personal information without
          prior consent, inclusive of comments containing personal information
          in CitizeX. Protecting privacy is essential to maintaining a safe
          online environment.
        </p>
        <p class="theme-color text-left my-2">
          <span class="fw-700">Reporting and Moderation:</span> Community
          members are encouraged to report any violations of the community
          guidelines. If a user's comments are reported for violating the rules,
          they may be marked as spam by community members. Administrators
          reserve the right to review reported content and may remove comments
          that violate the community guidelines. The moderation process aims to
          maintain a respectful and constructive environment for all users.
        </p>
        <form
          class="row m-0 square-form needs-validation my-3"
          *ngIf="!isFromReminder"
        >
          <div class="col-12 text-center">
            <button
              id="btn-modal-disagree"
              class="btn btn-outline-black mt-4 mb-2 mx-2 py-2 px-sm-2 px-3 font-14 modal-btn"
              data-dismiss="modal"
              (click)="closeModal()"
            >
              Disagree
            </button>
            <button
              id="btn-modal-agree-chat"
              *ngIf="reviewType == 'chat'"
              class="btn btn-black mt-4 mb-2 mx-2 py-2 px-sm-2 px-3 font-14 modal-btn"
              (click)="postAReview(categoryForm)"
            >
              Agree
            </button>
            <button
              id="btn-modal-agree-polling"
              *ngIf="reviewType == 'polling'"
              class="btn btn-black mt-4 mb-2 mx-2 py-2 px-sm-2 px-3 font-14 modal-btn"
              (click)="postAReview(categoryForm1)"
            >
              Agree
            </button>
          </div>
        </form>
        <div class="col-12 text-center" *ngIf="isFromReminder">
          <button
            id="btn-reminder-ok"
            class="btn btn-outline-black mt-4 mb-2 mx-2 py-2 px-sm-2 px-3 font-14 modal-btn"
            (click)="onOkClick()"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- have feedback modal  -->
<div
  class="modal fade havefeedbackmodal account-dialog account-dialog--feedback"
  *ngIf="!pageMode"
  tabindex="-1"
  role="dialog"
  id="haveFeedback"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered account-dialog__dialog"
    role="document"
  >
    <div class="modal-content account-dialog__content">
      <div class="modal-header account-dialog__header">
        <h5 class="modal-title">Have feedback?</h5>
        <button
          type="button"
          class="close account-dialog__close"
          aria-label="Close"
          data-dismiss="modal"
          (click)="resetFormData(feedbackForm)"
        >
          <span aria-hidden="true"
            ><app-icon
              name="x"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon
          ></span>
        </button>
      </div>
      <div class="modal-body account-dialog__body">
        <form
          class="account-dialog__form cx-standard-form"
          #feedbackForm="ngForm"
          (ngSubmit)="sendBugReportOrFeedback(feedbackForm)"
          novalidate
        >
          <div class="account-dialog__feedback-types" role="radiogroup">
            <label
              class="account-dialog__feedback-type"
              [class.is-selected]="reportBugFeedbackDTO.type === 'report a bug'"
            >
              <input
                type="radio"
                name="feedback"
                value="report a bug"
                [(ngModel)]="reportBugFeedbackDTO.type"
                required
                #type="ngModel"
              />
              <span>Report a bug</span>
            </label>
            <label
              class="account-dialog__feedback-type"
              [class.is-selected]="reportBugFeedbackDTO.type === 'feedback'"
            >
              <input
                type="radio"
                name="feedback"
                value="feedback"
                [(ngModel)]="reportBugFeedbackDTO.type"
                required
                #type="ngModel"
              />
              <span>Feedback</span>
            </label>
          </div>
          <div
            *ngIf="feedbackForm.submitted && type.invalid"
            class="text-danger mb-2 text-center"
          >
            Please select a feedback type.
          </div>
          <div class="form-group account-dialog__field">
            <label for="description">Description</label>
            <textarea
              id="description"
              class="form-control"
              rows="5"
              [(ngModel)]="reportBugFeedbackDTO.description"
              name="description"
              required
              maxlength="1000"
              #description="ngModel"
              NoLeadingWhitespace
              placeholder="What happened, and what did you expect instead?"
            ></textarea>
            <div
              *ngIf="feedbackForm.submitted && description.invalid"
              class="text-danger"
            >
              <span *ngIf="description.errors?.['required']"
                >Description is required.</span
              >
              <span *ngIf="description.errors?.['maxlength']"
                >You've reached the maximum limit of 1000 characters.</span
              >
            </div>
          </div>
          <div class="account-dialog__footer">
            <button
              type="button"
              class="btn account-dialog__secondary"
              data-dismiss="modal"
              (click)="resetFormData(feedbackForm)"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn account-dialog__primary"
              [disabled]="feedbackForm.invalid"
            >
              {{
                reportBugFeedbackDTO.type === 'feedback'
                  ? 'Send feedback'
                  : 'Send bug report'
              }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!------------have feedback modal----------->
<!------------Conversion-tab-Modal-Start--------------->
<div
  class="modal fade"
  *ngIf="!pageMode"
  id="conversionTabModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-centered conversation-Modal modal-dialog-custom"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title fw-700 font-18 mt-1">Create a Post</h5>
        <button
          type="button"
          class="close mt-2 font-32"
          data-dismiss="modal"
          aria-label="Close"
          (click)="reviewType = 'chat'"
        >
          <span aria-hidden="true"
            ><app-icon
              name="x"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon
          ></span>
        </button>
      </div>
      <div class="modal-body p-0">
        <div class="col-12 my-3 px-0">
          <ul class="nav nav-tabs review-nav justify-content-center">
            <li class="nav-item">
              <button
                id="tab-chat"
                class="nav-link d-flex flex-column justify-content-center align-items-center"
                [ngClass]="reviewType == 'chat' ? 'active' : ''"
                (click)="reviewType = 'chat'"
              >
                <app-icon
                  name="notebook-pen"
                  class="cx-icon--xl chat-img"
                  aria-hidden="true"
                ></app-icon>
                <span class="font-16 fw-600 ml-2">Post</span>
              </button>
            </li>
            <li class="nav-item">
              <button
                id="tab-polling"
                class="nav-link d-flex flex-column justify-content-center align-items-center"
                [ngClass]="reviewType == 'polling' ? 'active' : ''"
                (click)="reviewType = 'polling'"
              >
                <app-icon
                  name="list-checks"
                  class="cx-icon--xl Vector-img"
                  aria-hidden="true"
                ></app-icon>
                <span class="font-16 fw-600 ml-2">Polling</span>
              </button>
            </li>
            <li
              class="nav-item mt-sm-0 mt-3"
              *ngIf="
                user != null &&
                (user?.isPolitician ||
                  (user?.defaultProfileId == null &&
                    user?.reviewProfileId != null))
              "
            >
              <button
                id="tab-announcement"
                class="nav-link d-flex flex-column justify-content-center align-items-center"
                [ngClass]="reviewType == 'announcement' ? 'active' : ''"
                (click)="reviewType = 'announcement'"
              >
                <app-icon
                  name="megaphone"
                  class="cx-icon--xl announcement-img"
                  aria-hidden="true"
                ></app-icon>
                <span class="font-16 fw-600 ml-2">Announcement</span>
              </button>
            </li>
          </ul>
        </div>
        <div class="col-12 text-right">
          <button
            id="ok-btn-modal-conversation"
            class="btn btn-black my-3 mx-2 py-2 px-3 font-14"
            (click)="openModal()"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!------------Conversion-tab-Modal-end--------------->
<!-- Restriction Modal -->
<div
  class="modal fade"
  *ngIf="!pageMode"
  id="restrictModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered modal-sm"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body">
        <h1 class="text-center theme-color">
          <app-icon name="circle-alert" class="font-40"></app-icon>
        </h1>
        <h6 class="text-center bold my-3 theme-color">Sorry !</h6>
        <p class="text-center theme-color">
          Please complete all the verification steps first.
        </p>
        <div class="col-12 text-center">
          <button
            [routerLink]="['/signup']"
            class="btn btn-outline-black mt-4 mb-2 mx-2 py-1 font-12"
            data-dismiss="modal"
          >
            Get Verified
          </button>
        </div>
      </div>
      <!-- .modal-body -->
    </div>
    <!-- .modal-content -->
  </div>
  <!-- .modal-dialog -->
</div>
